import axios from 'axios';
import authModule from '../store/auth.module';
import { getToken } from './jwtHelper';
import { BASE_URL, CRM_URL } from './config';

const apiURL = BASE_URL;
// console.log(CRM_URL);
// console.log('BASE_URL: ', apiURL);

const crmInstance = axios.create({
  baseURL: CRM_URL,
  timeout: 60000,
})

const instance = axios.create({
  baseURL: apiURL,
  timeout: 20000,
});

const captcha = axios.create({
  baseURL: 'https://www.google.com/recaptcha/api',
  timeout: 20000,
});

async function htmlStatusRoute(status) {
  if (status === 401) {
    authModule.actions.logout();
    window.location = '/login';
    return true;
  }
  return false;
}

async function setHeaders(needAuth = true) {
  const token = await getToken('token');
  if (token && needAuth) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}

export async function APIGET(url, params = {}) {
  try {
    const resp = await instance({
      method: 'get',
      url: `${apiURL}/${url}`,
      headers: await setHeaders(),
      params,
      validateStatus: htmlStatusRoute,
    });
    // console.warn(`APIGET - ${url} response: `, resp);
    if (resp) {
      return resp.data;
    } else {
      return {
        status: 500,
        data: [],
        message: "errorMessages.INTERNAL_SERVER_ERROR",
      };
    }
  } catch (err) {
    return {
      status: 500,
      data: [],
      message: "errorMessages.INTERNAL_SERVER_ERROR",
    };
  }
}

export async function APIPOST(url, body) {
  try {
    const resp = await instance({
      method: 'post',
      url: `${apiURL}/${url}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: body,
    });
    // console.log(`%cAPIPOST - ${url}`, 'background-color: #27ae60; font-size: 14px; color: #FFFFFF;');
    // console.log(resp);
    if (resp) {
      return resp.data;
    } else {
      return {
        status: 500,
        data: [],
        message: "errorMessages.INTERNAL_SERVER_ERROR",
      };
    }
  } catch (err) {
    // console.log(`%cAPIPOST - ${url}`, 'background-color: #c0392b; font-size: 14px; color: #FFFFFF;');
    // console.log(err);
    return {
      status: 500,
      data: [],
      message: "errorMessages.INTERNAL_SERVER_ERROR",
    };
  }
}

export async function APICONTACTFORM(url, body) {
  try {
    const resp = await instance({
      method: 'post',
      url: `${apiURL}/${url}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: body,
    });
    if (resp.data.error) {
      return resp.data;
    } else {
      return resp.data;
    }
  } catch (err) {
    return { error: true, message: err };
  }
}

/**
 * @param {String} params.page
 * @param {String} params.lang
 * @returns {Promise<{error: boolean, message: *}>}
 * @constructor
 */

export async function APIGETPAGECONTENT(pageName, lang) {
  try {
    const resp = await instance({
      method: 'get',
      url: `${apiURL}/services/Webportal/ListPageContent/${pageName}/${lang}`,
      headers: await setHeaders(),
    });
    if (resp.data.error) {
      return resp.data;
    }
    return resp.data;
  } catch (err) {
    return { error: true, message: err };
  }
}

export async function APIDELETE(url, params = {}) {
  try {
    const resp = await instance({
      method: 'delete',
      url: `${apiURL}/${url}`,
      headers: await setHeaders(),
      params,
      validateStatus: htmlStatusRoute,
    });
    if (resp.data.error) {
      return resp.data;
    }
    return resp.data;
  } catch (err) {
    return { error: true, message: err };
  }
}

export async function APICAPTCHA(url, body) {
  try {
    const resp = await captcha({
      method: 'post',
      url: `https://www.google.com/recaptcha/api/${url}`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: body,
    });
    if (resp) {
      return { error: false, message: 'ok' };
    }
  } catch (err) {
    return { error: true, message: err };
  }
}

export async function APICRMGET(url, params = {}, needAuth = false) {
  try {
    const resp = await crmInstance({
      method: 'get',
      url: `${CRM_URL}/${url}`,
      headers: { 'Language': 'hu' },
      params,
      validateStatus: function (status) {
        return status >= 200;
      },
    });
    // console.log(`%cAPICRMGET - ${url} response: `, 'background-color: #27ae60; color: #ffffff; font-size: 12px;');
    // console.log(resp);
    if (resp) {
      return resp;
    } else {
      return {
        data: {
          status: 500,
          data: [],
          message: "errorMessages.INTERNAL_SERVER_ERROR",
        },
        status: 500,
      };
    }
  } catch (err) {
    return {
      data: {
        status: 500,
        data: [],
        message: "errorMessages.INTERNAL_SERVER_ERROR",
      },
      status: 500,
    };
  }
}
